
























import { DaLessonsService } from '../../../biz/remote/DaLessonsService';
import { MessageDialog } from '../../../utils/MessageDialog';
import { Session } from '../../../utils/Session';
import { dayjs, DTW_FORMAT_JA_WO_YM, DT_FORMAT_JA, T_FORMAT_JA } from '../../../../src_server/common/momentExtends';
import { LessonDTO } from '../../../../src_server/entity/dto/LessonDTO';
import { Vue, Component, Prop } from 'vue-property-decorator';
import CommonDialog from '../../../components/organisms/CommonDialog.vue';
import { LessonsService } from '../../../biz/remote/LessonsService';
import { LessonStates } from '../../../../src_server/entity/master/LessonStates';
import { LessonServiceFront } from '../../../biz/LessonServiceFront';
import { reportSend } from '../../../biz/reportSendLogic';

@Component({
  filters: {
    dateFormat: (dt: Date) => {
      return dayjs(dt).format(DTW_FORMAT_JA_WO_YM);
    },
    timeFormat: (dt: Date) => {
      return dayjs(dt).format(T_FORMAT_JA);
    },
  },
  components: { CommonDialog },
})
export default class DaCalssCalendarDialog extends Vue {
  private class_id = 0;
  private dto: LessonDTO = new LessonDTO();

  private get title() {
    return `${this.dto.student?.full_name} ${this.state} ${dayjs(this.start_dt).format(DTW_FORMAT_JA_WO_YM)} `;
  }

  get start_dt() {
    return this.dto.lessons?.start_dt;
  }
  get end_dt() {
    return this.dto.lessons?.end_dt;
  }

  get stateCss() {
    return LessonStates.getBadgeClassByState(this.dto.lessons?.reservation_state);
  }
  get full_name() {
    return this.dto.student?.full_name;
  }
  get state() {
    return LessonStates.getDaState(this.dto.lessons?.reservation_state);
  }

  get isCommit() {
    return LessonStates.COMMIT === this.dto.lessons?.reservation_state;
  }

  get isAlready() {
    return LessonStates.ALREADY === this.dto.lessons?.reservation_state;
  }

  get isReserevation() {
    return LessonStates.RESERVATION === this.dto.lessons?.reservation_state;
  }

  get canCancel() {
    return LessonStates.RESERVATION === this.dto.lessons?.reservation_state || LessonStates.COMMIT === this.dto.lessons?.reservation_state;
  }

  /**
   * 承認待ちをコミット
   */
  async commit(row: LessonDTO) {
    // MessageDialog.
    const isOK = await MessageDialog.confirm(`${row.student?.nickname}さんの${dayjs(row.lessons?.start_dt).format(DT_FORMAT_JA)}開始の予約を確定します。よろしいですか？`);

    if (isOK) {
      const biz = new DaLessonsService();
      row.commit = true;
      const response = await biz.reservationCommit(row.lessons, Session.getSessionBuildingId());
      if (response.hasError) {
        MessageDialog.alert(response.errorDescription);
        return;
      }
      await MessageDialog.alert(`${dayjs(row.lessons.start_dt).format(DT_FORMAT_JA)}の予約を確定しました`);
      // データをリロード
      this.loadData(this.class_id);
      this.$emit('changed');
    }
  }

  /**
   * 承認待ちや承認済みをキャンセル
   */
  async cancelLesson(row: LessonDTO) {
    const biz = new LessonServiceFront();
    row.commit = true;
    await biz.cancel(row.lessons.class_id!, async (class_id) => {
      await MessageDialog.alert(`${row.student?.nickname}さんの${dayjs(row.lessons.start_dt).format(DT_FORMAT_JA)}の予約をキャンセルしました`);
      // データをリロード
      this.loadData(this.class_id);
      this.$emit('changed');
    });
  }
  private report(class_id: number) {
    reportSend(this, class_id, 'report');
    // routeHelper(this, 'DaAdminDailyReportPage', { class_id: `${class_id}` });
  }
  private reportDoc(class_id: number) {
    reportSend(this, class_id, 'doc');
    // routeHelper(this, 'DaAdminDailyReportDocPage', { class_id: `${class_id}` });
  }

  private async loadData(class_id: number) {
    const biz = new LessonsService();
    const response = await biz.getLessonDto(class_id);
    this.dto = response.data;
  }

  /**
   * ダイアログを開く
   */
  public async show(class_id: number) {
    this.class_id = class_id;
    this.loadData(this.class_id);

    (this.$refs['DaCalssCalendarDialog'] as CommonDialog).show();
  }

  public close() {
    (this.$refs['DaCalssCalendarDialog'] as CommonDialog).hide();
  }
}
